export class ConflictError extends Error {
    private isConflictError: boolean;
    constructor(errorMsg: string) {
        super(errorMsg);
        this.isConflictError = true
    }
}